import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import en from "./locales/en.json";

export const SUPPORTED_LANGUAGES = ["de", "fr", "it", "en"];
export const LANGUAGE_LABELS = { de: "Deutsch", fr: "Français", it: "Italiano", en: "English" };
export const LANGUAGE_SHORT = { de: "DE", fr: "FR", it: "IT", en: "EN" };
const STORAGE_KEY = "fundio_lang";

export function normalizeLang(value) {
  const v = (value || "").toString().trim().toLowerCase().slice(0, 2);
  return SUPPORTED_LANGUAGES.includes(v) ? v : "de";
}

export function getStoredLang() {
  try { return normalizeLang(localStorage.getItem(STORAGE_KEY)); } catch { return "de"; }
}

export function storeLang(lang) {
  try { localStorage.setItem(STORAGE_KEY, normalizeLang(lang)); } catch { /* ignore */ }
}

i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    fr: { translation: fr },
    it: { translation: it },
    en: { translation: en },
  },
  lng: getStoredLang(),
  fallbackLng: "de",
  supportedLngs: SUPPORTED_LANGUAGES,
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLanguage(lang) {
  const l = normalizeLang(lang);
  storeLang(l);
  if (i18n.language !== l) i18n.changeLanguage(l);
  try { document.documentElement.lang = l; } catch { /* ignore */ }
}

export default i18n;
